import { render, staticRenderFns } from "./WPicEditor.vue?vue&type=template&id=7663db27&"
import script from "./WPicEditor.vue?vue&type=script&lang=ts&"
export * from "./WPicEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports